export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Following-Gray-25a4956e72106dd3ed5c132a3182e915.svg";